import { apiFGTS } from '../http/httpClient'

export interface Table {
  tableName: string
  commission: number
  bonus: number
  success: boolean
  IDTabela: number
  message: string
  CodigoTabela: string
  DataPrimeiroVencimento: string
  DataUltimoVencimento: string
  Prazo: number
  ValorPrincipal: number
  ValorBloqueado: number
  IOF: number
  ValorLiquidoCliente: number
  ValorSolicitado: number
  ValorSeguro: number
  ValorTC: number
  CodigoProduto: number
  CodigoEmpregador: number
  CodigoOrgao: number
  Parcelas: {
    NumeroParcela: number
    ValorParcela: number
    DataVencimento: string
    ValorPrincipal: number
    ValorJuros: number
  }[]
  Taxas: {
    name: string
    mensal: number
    anual: number
  }[]

  // INGLES
  tableId?: number
  tableCode?: string
  employerCode?: number
  agencyCode?: number
  productCode?: number
  term?: number
  firstDueDate?: string
  lastDueDate?: string
  amount?: number
  requestedAmount?: number
  principalAmount?: number
  blockedAmount?: number
  iof?: number
  insuranceAmount?: number
  processingFee?: number
  installments?: {
    n: number
    value: number
    dueDate: string
    principalValue: number
    interestValue: number
  }[]
  fees?: {
    name: string
    monthly: number
    yearly: number
  }[]
}
export interface getAvailableCreditResponse {
  tables: Table[]
}

export interface getAvailableCreditParams {
  prazo?: number
}

export async function getAvailableCredit(
  cpf: number,
  params?: getAvailableCreditParams | undefined,
) {
  const { data } = await apiFGTS.patch<getAvailableCreditResponse>(
    `/transaction/${cpf}`,
    null,
    { params },
  )

  return data
}
